import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'

import { Header } from './Header'
import { Footer } from './Footer'
import { TicketFormProvider, TicketForm } from './TicketForm'
import { SupportTicket } from '../types'

export function Content(ticket: SupportTicket) {
  const { ready } = useConfigureController(ticket)

  if (!ready) return null

  return (
    <TicketFormProvider>
      <ModalContent header={<Header />} footer={<Footer />}>
        <TicketForm />
      </ModalContent>
    </TicketFormProvider>
  )
}
